module.exports = __webpack_public_path__ + "img/1.122bfe39.png";